// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608121605/js/" + chunkId + "." + {"44":"ace89252","225":"9eaa33dd","481":"2a1660cb","486":"5a6aecf8","770":"2a09da7b"}[chunkId] + ".0.31571377561851777.chunk.js";
};